import { cpUrl } from "content";

export default [
  {
    type: "Register Investor",
    url: `${cpUrl}/register/forex/investor`,
  },
];
